export default "__VITE_ASSET__DHtPyiek__"